import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";
import { MultiSelect } from "react-multi-select-component";

import { countryOptions, classesOptions } from "../variables/searchOptions";

import "../css/App.css";

function Form() {
  const { user } = UserAuth();
  const navigate = useNavigate();

  // State for input values
  const [client, setClient] = useState("");
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  // const [classes, setClasses] = useState([]); // Initial value for local_spelling
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const host = process.env.REACT_APP_SERVER;

  useEffect(() => {
    if (user === null) {
      navigate("/signin");
    }
  }, [user, navigate]);

  const handleCreate = async () => {
    setLoading(true); // Set loading state to true

    console.log("CREATING");
    try {
      const formData = {
        client,
        name,
        category,
        description,
        creator: user.displayName,
        num_names: 0,
        // nice_classes: classes.map((cls) => cls.value),
        status: "created",
      };

      console.table(formData);
      console.log(formData);

      const response = await fetch(`${host}/api/projects`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const responseData = await response.json();
        const { project } = responseData.data;

        // Extract the projectId from the server response
        const projectId = project.id;

        setSuccess(true); // Set success state to true
        setTimeout(() => {
          console.log("Project created with ID:", projectId);
          navigate(`/projects/${projectId}`); // Navigate to the project page using the extracted projectId
        }, 1500); // Delay for 1.5 seconds
      } else {
        // Handle error case
        console.error("Failed to create project");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  if (!user?.email) {
    return null;
  }

  return (
    <div className="container mx-auto text-center">
      <div className="flex flex-row">
        {/* First Column */}
        <div className="flex flex-col gap-5 w-full p-5">
          <div className="flex flex-row gap-5">
            <div className="w-full">
              <input type="text" placeholder="Client" className="select select-bordered w-full bg-none textarea-secondary" value={client} onChange={(e) => setClient(e.target.value)} />
            </div>
            <div className="w-full">
              <input type="text" placeholder="Name" className="select select-bordered w-full bg-none textarea-secondary" value={name} onChange={(e) => setName(e.target.value)} />
            </div>
            <div className="w-full">
              <input type="text" placeholder="Category" className="select select-bordered w-full bg-none textarea-secondary" value={category} onChange={(e) => setCategory(e.target.value)} />
            </div>
          </div>
          <div className="flex flex-col gap-5">
            <textarea type="text" placeholder="Description" className="textarea textarea-secondary textarea-md " value={description} onChange={(e) => setDescription(e.target.value)} />
          </div>

          <div className="flex flex-col gap-5">
            {/* <MultiSelect options={countryOptions} value={countries} onChange={setCountries} labelledBy={"Select Countries"} isCreatable={false} hasSelectAll={false} className="pb-5 dark" /> */}
          </div>

          <div className="flex justify-center">
            <button className={`btn btn-primary ml-2 ${loading ? "btn-disabled" : ""}`} onClick={handleCreate} disabled={loading}>
              {loading ? "Creating..." : "CREATE"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Form;
